export default __webpack_public_path__ + "static/media/FirstCommunity-Logo.352bfd26.png";